import React from 'react';
import { Link } from 'react-router-dom';
import { Swords, Trophy, LogIn } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../hooks/useAuth';
import { PageLayout } from '../../components/layout/PageLayout';
import { useI18n } from '../../contexts/I18nContext';

export function PvpChoice() {
  const { user } = useAuth();
  const { t, getPathForLang } = useI18n();

  if (!user) {
    return (
      <PageLayout disableAds={true}>
        <Helmet>
          <title>{t('pvp_choice.seo.title')}</title>
          <meta name="description" content={t('pvp_choice.seo.description')} />
        </Helmet>
        <div className="container mx-auto px-4 py-6 pb-8 md:pb-8">
          {/* Section principale */}
          <div className="space-y-6 max-w-lg mx-auto">
            {/* Mode PvP */}
            <div>
              <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3 px-2">{t('pvp_choice.category_title')}</h2>
              <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <Link
                  to={getPathForLang('/login')}
                  className="flex items-center p-4 hover:bg-blue-50 transition-colors"
                >
                  <div className="bg-purple-100 p-3 rounded-full">
                    <LogIn className="w-5 h-5 text-purple-600" />
                  </div>
                  <div className="ml-3">
                    <h2 className="font-semibold text-gray-900">{t('pvp_choice.login.title')}</h2>
                    <p className="text-xs text-gray-600">{t('pvp_choice.login.description')}</p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout disableAds={true}>
      <Helmet>
        <title>{t('pvp_choice.seo.title')}</title>
        <meta name="description" content={t('pvp_choice.seo.description')} />
      </Helmet>
      <div className="container mx-auto px-4 py-6 pb-8 md:pb-8">
        {/* Section principale */}
        <div className="space-y-6 max-w-lg mx-auto">
          {/* Mode PvP */}
          <div>
            <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3 px-2">{t('pvp_choice.category_title')}</h2>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <Link
                to={getPathForLang('/pvp/queue')}
                className="flex items-center p-4 border-b border-gray-100 hover:bg-blue-50 transition-colors"
              >
                <div className="bg-red-100 p-3 rounded-full">
                  <Swords className="w-5 h-5 text-red-600" />
                </div>
                <div className="ml-3">
                  <h2 className="font-semibold text-gray-900">{t('pvp_choice.play.title')}</h2>
                  <p className="text-xs text-gray-600">{t('pvp_choice.play.description')}</p>
                </div>
              </Link>

              <Link
                to={getPathForLang('/pvp/ranking')}
                className="flex items-center p-4 hover:bg-blue-50 transition-colors"
              >
                <div className="bg-amber-100 p-3 rounded-full">
                  <Trophy className="w-5 h-5 text-amber-600" />
                </div>
                <div className="ml-3">
                  <h2 className="font-semibold text-gray-900">{t('pvp_choice.ranking.title')}</h2>
                  <p className="text-xs text-gray-600">{t('pvp_choice.ranking.description')}</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
} 